import { render, staticRenderFns } from "./ContentChildrenLinks.vue?vue&type=template&id=d45da416&"
import script from "./ContentChildrenLinks.vue?vue&type=script&lang=js&"
export * from "./ContentChildrenLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports